export const RelatorioNameMapper = {
  RELATORIO_DIARIO: 'Relatório diário',
  RELATORIO_EXTRATO: 'Extrato',
  RELATORIO_FLUXO: 'Fluxo de caixa',
  RELATORIO_CATEGORIA: 'Relatório por categoria',
  RELATORIO_CONTA: 'Relatório por conta',
  RELATORIO_CONTATO: 'Relatório por contato',
  RELATORIO_MENSAL_MEI: 'Relatório Mensal MEI',
  RELATORIO_DASN: 'Relatório DASN',
};

export const enumRelatorios = {
  Diário: 'RELATORIO_DIARIO',
  Extrato: 'RELATORIO_EXTRATO',
  'Fluxo de caixa': 'RELATORIO_FLUXO',
  'Relatório por categoria': 'RELATORIO_CATEGORIA',
  'Relatório por conta': 'RELATORIO_CONTA',
  'Relatório por contato': 'RELATORIO_CONTATO',
  'Relatório Mensal MEI': 'MENSAL_MEI',
  'Relatório DASN': 'DASN',
};
